interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
  articleSection?: string;
  articleTags?: string[];
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl = 'https://buliangyanjiusuo.com',
  ogImage = 'https://readdy.ai/api/search-image?query=Abstract%20research%20and%20exploration%20concept%20with%20warm%20cream%20and%20terracotta%20tones%2C%20minimalist%20editorial%20style%2C%20intellectual%20atmosphere%2C%20soft%20gradient&width=1200&height=630&seq=og-default&orientation=landscape',
  ogType = 'website',
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
  articleSection,
  articleTags,
}: SEOMetaProps) {
  const fullTitle = title.includes('不良研究所') ? title : `${title} - 不良研究所`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="不良研究所" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {articlePublishedTime && (
        <meta property="article:published_time" content={articlePublishedTime} />
      )}
      {articleModifiedTime && (
        <meta property="article:modified_time" content={articleModifiedTime} />
      )}
      {articleAuthor && <meta property="article:author" content={articleAuthor} />}
      {articleSection && <meta property="article:section" content={articleSection} />}
      {articleTags?.map((tag) => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}
    </>
  );
}